import { EmptySlide } from 'components/lesson-builder/empty-slide'
import { PresentationSlide } from 'components/lesson-builder/presentation-slide'
import questionMultiBubble from 'img/question-multi-bubble.svg'
import questionSingleBubble from 'img/question-single-bubble.svg'
import React, { useMemo } from 'react'
import 'css/components/lesson-builder/sidebar.css'
const SlideGroup = ({
	lessonPdf,
	presentationSlide,
	questionSlides,
	currentSlide,
	i,
	onSlideClick
}) => {
	const slideQs = questionSlides
		.filter(q => q.slide === presentationSlide.index)
		.toSorted((a, b) => a.priority < b.priority)

	return (
		<>
			<div
				className="sidebar-presentation-slide"
				onClick={() => onSlideClick && onSlideClick(presentationSlide.number)}
			>
				{i + 1}
				<PresentationSlide
					lessonPdf={lessonPdf}
					pageNumber={i + 1}
					isCurrent={currentSlide === presentationSlide.number}
					width={150}
				/>
			</div>
			{slideQs.map((slide, j) => (
				<div
					key={ `sidebar-question-slide-${i}-${j}` }
					className="sidebar-question-slide"
					onClick={() => onSlideClick && onSlideClick(slide.number)}
				>
					<div className="sidebar-question-slide-number">
						{`${i + 1}.${j + 1}`}
						{slide.questionsByDifficulty[0].questions.length === 1 ?
							<img src={questionSingleBubble} alt="single bubble" /> :
							<img src={questionMultiBubble} alt="multiple bubble" />}
					</div>
					<EmptySlide
						isCurrent={currentSlide === slide.number}
						isApproved={slide.allApproved}
					/>
				</div>
			))}
		</>
	)
}

export const Sidebar = ({
	lessonPdf,
	slides,
	currentSlide,
	hide,
	onSlideClick
}) => {
	const numberedSlides = useMemo(() => 
		slides.map((s, i) => ({ ...s, number: i }))
	, [slides]);

	const presentationSlides = useMemo(() => 
		numberedSlides.filter(s => s.type === 'presentation')
	, [numberedSlides]);

	const questionSlides = useMemo(() => 
		numberedSlides.filter(s => s.type !== 'presentation')
	, [numberedSlides]);

	return (
		<div className={'sidebar ' + (hide ? 'hide' : '')}>
			{presentationSlides.map((presentationSlide, i) => (
				<SlideGroup
					key={`slide-group-${i}`}
					lessonPdf={lessonPdf}
					presentationSlide={presentationSlide}
					questionSlides={questionSlides}
					currentSlide={currentSlide}
					i={i}
					onSlideClick={onSlideClick}
				/>
			))}
		</div>
	)
}
